import { createContext } from 'react';

const OrderItemsContext = createContext(null);

export { OrderItemsContext };
